import { ModelBase } from '../abstract/model-base.model';
import { AgentUsageCost, AgentUsageTokens } from 'src/app/@core/services/ai/agent-relay.client';

/** Consommation mensuelle agrégée de l'agent IA pour la société (#881). */
export class AgentMonthlyUsage extends ModelBase {

    static override CLASS_NAME: string = 'AgentMonthlyUsage';

    private _month!: string;
    private _tokens!: AgentUsageTokens;
    private _cost!: AgentUsageCost | null;

    /** Mois agrégé au format `YYYY-MM`. */
    public get month(): string {
        return this._month;
    }

    public set month(value: any) {
        this._setValue('_month', value, 'string');
    }

    /** Détail des tokens consommés sur le mois. */
    public get tokens(): AgentUsageTokens {
        return this._tokens;
    }

    public set tokens(value: any) {
        this._setValue('_tokens', value, 'any');
    }

    /** Coût brut (sans marge) du mois (`null` si non calculable). */
    public get cost(): AgentUsageCost | null {
        return this._cost;
    }

    public set cost(value: any) {
        this._setValue('_cost', value, 'any');
    }
}
